export default __webpack_public_path__ + "static/taskdeploy1-33c69f65884dc69de06d47f5f5050f95.png";